import { cn } from "lib/utils"
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
  TooltipArrow,
} from "components/ui/tooltip"

export default (props: {
  children: any
  isError?: boolean
  delayDuration?: number | undefined
  text?: string | number
  className?: string
  contentClassName?: string
  disableHoverableContent?: boolean
  asChild?: boolean
}) => {
  if (!props.children) return null
  return (
    <TooltipProvider>
      <Tooltip
        delayDuration={props.delayDuration ?? 0}
        disableHoverableContent={props.disableHoverableContent ?? false}
      >
        <TooltipTrigger asChild={props.asChild ?? false}>
          {props.children}
        </TooltipTrigger>
        <TooltipContent
          hidden={!props.text}
          className={cn(
            props.isError && "bg-red-500 text-white",
            props.contentClassName
          )}
        >
          <div>{props.text}</div>
          <TooltipArrow className={cn(props.isError && "fill-red-500")} />
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
